import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const Remove = (props: IconProps): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="Remove" {...rest}>
      <path fill="currentColor" d="M5 11h14v2H5z" />
    </SvgIcon>
  );
};
